import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import Vue from 'vue';
Vue.filter('month', function (val) {
  var showYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  val = String(val);
  var regx = /\w+\s(\w+)\s\d+\s(\d+)./;

  if (!showYear) {
    return regx.exec(val)[1];
  } else {
    return regx.exec(val)[1] + ' ' + regx.exec(val)[2];
  }
});